import { Page } from "components/layout"
import SelectLedgerForm from "./SelectLedgerForm"

const SelectLedgerPage = () => {
  return (
    <Page>
      <SelectLedgerForm />
    </Page>
  )
}

export default SelectLedgerPage
